import React from "react";

const FieldInfo = ({ children: text, visible = true, ...otherProps }) => {
  if (!visible) return null;

  return <span className="help-block text-muted">{text}</span>;
};

export default FieldInfo;
